import { render, staticRenderFns } from "./ExaminationPopup.vue?vue&type=template&id=aee1b248&scoped=true&"
import script from "./ExaminationPopup.vue?vue&type=script&lang=js&"
export * from "./ExaminationPopup.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationPopup.vue?vue&type=style&index=0&id=aee1b248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee1b248",
  null
  
)

export default component.exports